import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/utils.js';

const SIZE_CLASSES = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

export function Spinner({ className, size = 'md', ...props }) {
  return (
    <Loader2
      role="status"
      aria-label="Loading"
      className={cn('animate-spin text-muted-foreground', SIZE_CLASSES[size], className)}
      {...props}
    />
  );
}
